import { AfterViewChecked, Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[appScrollbarResize]',
    standalone: false
})
export class ScrollbarResizeDirective implements AfterViewChecked {
  // @Input()
  // appScrollbarResize!: ElementRef;

  constructor(private elementRef: ElementRef) {
  }

  ngAfterViewChecked() {
    const width = this.elementRef.nativeElement.clientWidth - this.elementRef.nativeElement.offsetWidth;
    setTimeout(() => {
      Array.from((this.elementRef.nativeElement as HTMLElement).children).forEach(element => (element as HTMLElement).style.marginRight = `${width}px`);
    }, 0);
  }
}
